export var Web3TransactionType;
(function (Web3TransactionType) {
    Web3TransactionType["MINT"] = "MINT";
    Web3TransactionType["TRANSFER"] = "TRANSFER";
    Web3TransactionType["BURN"] = "BURN";
    // CLAIM       = 'CLAIM',
})(Web3TransactionType || (Web3TransactionType = {}));
//# sourceMappingURL=transaction-type.enum.js.map